// extracted by mini-css-extract-plugin
export default {"chartBlock":"statistic_chartBlock__F1OwX"};